import { Link } from "react-router-dom";

const quickTags = [
  { label: "热血", to: "/anime?genre=热血" },
  { label: "科幻", to: "/anime?genre=科幻" },
  { label: "恋爱", to: "/anime?genre=恋爱" },
  { label: "治愈", to: "/anime?genre=治愈" },
  { label: "机战", to: "/anime?genre=机战" },
  { label: "国漫", to: "/anime?region=中国" },
];

export default function QuickExplore() {
  return (
    <section className="w-full bg-background-50 px-4 md:px-8 pt-10 md:pt-12">
      <div className="max-w-7xl mx-auto rounded-lg bg-primary-50 border border-primary-100 p-5 md:p-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6">
          <div className="flex items-center gap-2 shrink-0">
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-compass-3-line"></i>
            </span>
            <span className="text-sm font-bold text-foreground-900 whitespace-nowrap">快速发现</span>
          </div>
          <div className="flex items-center flex-wrap gap-2">
            {quickTags.map((tag) => (
              <Link
                key={tag.label}
                to={tag.to}
                className="px-3 py-1.5 rounded-full bg-background-50 border border-primary-100 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                {tag.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}